<script setup>
import { computed } from 'vue';

import { FileType } from '@/enums';
import ListingStatusBadge from './ListingStatusBadge.vue';

const props = defineProps({
    data: {
        type: Object,
        required: true,
    },
});

const image = computed(() => {
    if (!props.data.files || props.data.files.length === 0) {
        return null;
    }

    return props.data.files.filter(file => file.type === FileType.IMAGE)[0].url;
});
</script>

<template>
    <div class="flex rounded-2xl border border-white-foreground/10 h-[180px]">
        <div class="w-[40%] h-full shrink-0 bg-[#131313] flex items-center justify-center">
            <img loading="lazy" :src="image" :alt="data.title" class="w-full h-auto max-h-full object-cover select-none" />
        </div>
        <div class="p-4 grow">
            <div class="text-base font-bold">
                {{ $money(data.price) }}
            </div>
            <app-line-clamp :lines="1" hide-read-more>
                <h3 class="text-sm">{{ data.title }}</h3>
            </app-line-clamp>
            <p class="text-xs text-muted">{{ data.state.name }}</p>

            <ListingStatusBadge class="mt-2" :status="data.status" />
            <div class="flex items-center gap-2 mt-4">
                <app-button
                    as="RouterLink"
                    :to="{ name: 'marketplace.listing.show', params: { id: data.id } }"
                    color="primary-border" capitalize compact>
                    View Listing
                </app-button>
            </div>
        </div>
    </div>
</template>
